export default process.env.__TESTING_RIMRAF_PLATFORM__ || process.platform
